import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
export default function List(props) {
  return props.list.length ? (
    <div className="history-details-modal-box" id={props.id}>
      <h5>{props.title}</h5>
      <Paper sx={{ width: '100%' }} className="transaction-detail-history">
        <TableContainer
          component={Paper}
          className="tableContainer"
          id="tab-container"
        >
          <Table stickyHeader aria-label="sticky table">
            {/* Column Headers */}
            <TableHead>
              <TableRow>
                {Object.keys(props.list[0])
                  .map((x) => ({ id: x }))
                  .map((column) => (
                    <TableCell
                      key={column.id}
                      align={column.numeric ? 'right' : 'left'}
                      padding={column.disablePadding ? 'none' : 'normal'}
                    >
                      <span className={'col-header table-header pr-2'}>
                        {column.id}
                      </span>
                    </TableCell>
                  ))}
              </TableRow>
            </TableHead>

            {/* Table Content */}
            <TableBody>
              {props.list.map((row, id) => {
                return (
                  <TableRow role="checkbox" tabIndex={-1} key={id}>
                    {Object.keys(props.list[0])
                      .map((x) => ({ id: x }))
                      .map((column) => {
                        const value = row[column.id];
                        return column.id === 'Location' ? (
                          <TableCell key={column.id} align={column.align}>
                            {value?.split(' > ').map((v, i) => {
                              return (
                                <span key={i} className="search-meta-value">
                                  {'' + v}
                                </span>
                              );
                            })}
                          </TableCell>
                        ) : (
                          <TableCell key={column.id} align={column.align}>
                            {column.format && typeof value === 'number'
                              ? column.format(value)
                              : value}
                          </TableCell>
                        );
                      })}
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  ) : null;
}
